import { isToolActionKey } from '@shared/types/tool-actions';
import type { LightViewAction } from '@shared/types/views';
import type { ConnectionRequirement } from '@shared/types/integrations';

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const getActionConnectionRequirements = (
  action: LightViewAction | null | undefined
): ConnectionRequirement[] =>
  action?.type === 'server_action' || action?.type === 'inline_capability'
    ? (action.connectionRequirements ?? [])
    : [];

export const isLightViewActionLike = (value: unknown): value is LightViewAction =>
  isRecord(value) &&
  typeof value.type === 'string' &&
  ((value.type === 'link' &&
    typeof value.label === 'string' &&
    typeof value.href === 'string') ||
    (value.type === 'copy_text' &&
      typeof value.label === 'string' &&
      typeof value.text === 'string') ||
    (value.type === 'tool_handoff' &&
      typeof value.label === 'string' &&
      typeof value.toolKey === 'string' &&
      isRecord(value.prefill) &&
      Object.values(value.prefill).every((entry) => typeof entry === 'string')) ||
    (value.type === 'server_action' &&
      typeof value.label === 'string' &&
      typeof value.actionKey === 'string' &&
      isToolActionKey(value.actionKey) &&
      typeof value.sourceRunId === 'string') ||
    (value.type === 'inline_capability' &&
      typeof value.label === 'string' &&
      (value.capabilityKey === 'domino.web_research' ||
        value.capabilityKey === 'domino.draft_email' ||
        value.capabilityKey === 'domino.transient_recipe') &&
      typeof value.prompt === 'string') ||
    (value.type === 'flow_handoff' &&
      typeof value.label === 'string' &&
      typeof value.seedPrompt === 'string' &&
      (value.flowId === undefined || typeof value.flowId === 'string')));
